<template>
    <div id="start_packet_list_component"
         class="start-packet-list-component">
        <p style="margin-bottom: 11px">Congratulations! Below your mining packages:</p>
        <div class="codes-list-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                        <tr>
                            <th><p>Value</p></th>
                            <th><p>Amount paid</p></th>
                            <th><p><strong>Date of purchase</strong></p></th>
                            <th><p>Status</p></th>
                            <th><p>Time to make an&nbsp;upgrade</p></th>
                            <th><p></p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(single, index) in packages"
                            :key="index">
                            <td><p>FND {{ single.position }}</p></td>
                            <td><p>FND {{ money.format(single.value, 'fnd') }}</p></td>
                            <td><p><strong>{{ datetime.utcToLocal(single.date) }}</strong></p></td>
                            <td>
                                <p v-if="(!single.was_upgraded && !single.is_expired) || !single.is_expired">working</p>
                                <p v-else>not working</p>
                            </td>
                            <td>
                                <p v-if="countDays(single.date).days > 0 && !single.is_expired && !single.was_upgraded">{{ countDays(single.date).days + ' ' + countDays(single.date).word }}</p>
                                <p v-if="countDays(single.date).days < 1 && !single.is_expired && !single.was_upgraded">expired (time is over)</p>
                                <p v-if="single.was_upgraded || (single.was_upgraded && single.is_expired)">upgraded</p>
                            </td>
                            <td>
                                <button class="button--primary"
                                        @click="buyPacket(single.position, single.id)"
                                        v-if="!single.is_expired && countDays(single.date).days >= 0 && parseInt(single.position) < 25000 && !single.was_upgraded">Upgrade</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p v-if="packages.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        dependencies: ['datetime', 'money', 'packet'],
        data () {
            return {
                packets: [100, 250, 500, 1000, 5000, 10000, 25000],
                loader: false,
                items: 25
            }
        },
        computed: {
            packages () {
                return this.$store.getters.boughtPackets;
            },
            currentPage () {
                return this.$store.getters.boughtPacketsSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.boughtPacketsSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.boughtPacketsSettings.numberOfPages;
            }
        },
        methods: {
            countDays (date) {
                let dateStart = moment(date),
                    dateStop = moment(),
                    diff = dateStop.diff(dateStart, 'days'),
                    days = 50 - parseInt(diff),
                    word = days > 1 ? 'days' : 'day';

                return {
                    days: days,
                    word: word
                };
            },
            getNextPacket (packetValue) {
                for (let value in this.packets) {
                    if (this.packets[value] === packetValue) return parseInt(value) + 1;
                }
            },
            buyPacket (index, packetId) {
                this.packet.create(index);
                this.$store.commit('modals', {
                    modal: 'buyPacket',
                    data: {
                        visible : true,
                        packet  : this.packet,
                        select  : this.packets[this.getNextPacket(parseInt(index))],
                        current : parseInt(index),
                        upgrade : packetId
                    }
                });
            },
            /**
             * Get data with transactions
             */
            getData () {
                this.loader = true;

                let settings = this.$store.getters.boughtPacketsSettings;

                this.$store.dispatch('loadBoughtPackets', {
                    params: settings
                }).then(() => {
                    this.loader = false;
                });
            },
            /**
             * Change sort
             */
            changeSort: function (field) {
                this.$store.dispatch('boughtPacketsSetSort', field).then(() => {
                    this.getData();
                });
            },

            /**
             * Set default settings
             */
            clearSettings () {
                this.$store.dispatch('boughtPacketsSettingsClear').then(() => {
                    this.getData();
                    this.items = 25;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('boughtPacketsSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('boughtPacketsSetPage', page).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.boughtPacketsSettings;

            this.$store.dispatch('loadBoughtPackets', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .start-packet-list-component {
        position: relative;
        margin-bottom: 34px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/start-packet/StartPacketList.vue